// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignUp_Form__1K_oH","Box":"SignUp_Box__XleMv","ButtonBox":"SignUp_ButtonBox__V5Neu","googleSignInButton":"SignUp_googleSignInButton__hvDc4"};